import { z } from "zod"

export const NotificationAssignmentSchema = z.object({
  role: z.string(),
  notification_key: z.string(),
})

export const NotificationAssignmentFormSchema = z.object({
  role: z.string().min(1, "notificationAssignments.validation.roleRequired"),
  notification_key: z
    .string()
    .min(1, "notificationAssignments.validation.notificationKeyRequired"),
})

export const NOTIFICATION_TYPES = [
  { value: "new_document", label: "Novo Documento" },
  { value: "new_document_email", label: "Novo Documento (Email)" },
  { value: "new_user", label: "Novo Utilizador" },
  { value: "new_user_email", label: "Novo Utilizador (Email)" },
]

export type NotificationAssignment = z.infer<
  typeof NotificationAssignmentSchema
>
export type NotificationAssignmentFormValues = z.infer<
  typeof NotificationAssignmentFormSchema
>
